// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"ddf3b525","181":"3505ece2","276":"c32d4a7c","711":"06ba7c90"}[chunkId] + ".chunk.js";
};